import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import WhatsAppModal from './WhatsAppModal';
import '../styles/FloatingButton.css';

const FloatingButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [callColor, setCallColor] = useState('rgb(0, 106, 255)');

  useEffect(() => {
  const interval = setInterval(() => {
    const newColor = getRandomRGB();
    setCallColor(newColor);
  }, 2000); // every 2 seconds

  return () => clearInterval(interval);
}, []);

  // Generate a random RGB color
const getRandomRGB = () => {
  const colors = [
    'rgb(255, 51, 51)',     // red
    'rgb(51, 102, 255)',    // blue
    'rgb(0, 204, 102)',     // green
    'rgb(153, 51, 255)',    // purple
    'rgb(255, 51, 153)',    // pink
    'rgb(0, 102, 51)',      // dark green
    'rgb(255, 204, 0)',     // yellow ✅

  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

  useEffect(() => {
    const interval = setInterval(() => {
      setCallColor(getRandomRGB());
    }, 1500); // change color every 1.5 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);
  const isYellow = callColor === 'rgb(255, 204, 0)';
  return (
    <>
      {/* Call Button - bottom left */}
            <a
        href="tel:+917046062908"
        className="floating-button call-btn"
        style={{
          backgroundColor: callColor,
          boxShadow: `0 0 20px ${callColor}`,
          color: isYellow ? '#000' : '#fff' // black icon only if yellow
        }}
        title="Call Now"
      >
        <FaPhoneAlt />
      </a>

      {/* WhatsApp Button - opens modal */}
      <button
        className="floating-button whatsapp-btn"
        onClick={() => setIsModalOpen(true)}
        title="Chat on WhatsApp"
      >
        <FaWhatsapp />
      </button>

      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default FloatingButton;
